import { isEqual } from "lodash";
import { cleanObject } from "./cleanObject";

/**
 * Compares two values after cleaning them with cleanObject.
 * This is useful for checking if two objects are equal after removing
 * undefined properties and functions.
 *
 * @param oldValue - The first value to compare.
 * @param newValue - The second value to compare.
 * @returns True if the cleaned values are equal, false otherwise.
 */
export const cleanIsEqual = <T>(oldValue: T, newValue: T): boolean =>
  isEqual(cleanObject(oldValue), cleanObject(newValue));
